import ApiAIRequest from "../../api-request/api-ai";


export default class ApiAI {

    static getAIChat(chatId: ID) {
        return ApiAIRequest.GET(this, 'chat/{0}'.f(chatId));
    }

    static updateAIChat(chatId: ID, payload: any) {
        return ApiAIRequest.PUT(this, 'chat/{0}'.f(chatId), payload);
    }

    static getAIChats() {
        return ApiAIRequest.GET(this, 'chats');
    }

    static newAIChat(params: any) {
        return ApiAIRequest.POST(this, 'new-chat', params)
    }
    static removeAIChat(chatId: ID) {
        return ApiAIRequest.DELETE(this, 'chat/{0}'.f(chatId))
    }

    static sendMessage(chatId: ID, params: any) {
        return ApiAIRequest.POST(this, 'chat/{0}'.f(chatId), params)
    }

}
